import React, { Component } from 'react';
import { SaveButton } from '../modalButtons';

var PROVIDERS = [
    {
        key: 'openai',
        name: 'OpenAI',
        description: 'Used by AI Chatbots, IVR generation, knowledge-base ingestion, and voice-option suggestions.',
        fields: [
            { key: 'apiKey', label: 'API Key', placeholder: 'sk-...', secret: true }
        ]
    },
    {
        key: 'anthropic',
        name: 'Anthropic (Claude)',
        description: 'Reserved for future Claude-powered features.',
        fields: [
            { key: 'apiKey', label: 'API Key', placeholder: 'sk-ant-...', secret: true }
        ]
    },
    {
        key: 'azureOpenAI',
        name: 'Azure OpenAI',
        description: 'Use Azure-hosted OpenAI deployments instead of api.openai.com.',
        fields: [
            { key: 'apiKey', label: 'API Key', placeholder: 'azure key', secret: true },
            { key: 'endpoint', label: 'Endpoint', placeholder: 'https://your-resource.openai.azure.com' },
            { key: 'deployment', label: 'Deployment Name', placeholder: 'gpt-4o' }
        ]
    },
    {
        key: 'google',
        name: 'Google AI (Gemini)',
        description: 'Reserved for future Gemini-powered features.',
        fields: [
            { key: 'apiKey', label: 'API Key', placeholder: 'AIza...', secret: true }
        ]
    }
];

var labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: '700', letterSpacing: '1px',
    textTransform: 'uppercase', color: '#888', marginBottom: '6px'
};
var inputStyle = {
    width: '100%', padding: '9px 12px', border: '1px solid #ccc', borderRadius: '6px',
    fontSize: '14px', color: '#222', background: '#fff', boxSizing: 'border-box'
};

class AISettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            edits: {},
            reveal: {},
            savingKey: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.savingKey) {
            this.setState({ savingKey: '', edits: this.dropProviderEdits(this.state.savingKey) });
        }
    }

    dropProviderEdits(key) {
        var copy = Object.assign({}, this.state.edits);
        delete copy[key];
        return copy;
    }

    getValue(providerKey, fieldKey) {
        var edits = this.state.edits[providerKey];
        if (edits && Object.prototype.hasOwnProperty.call(edits, fieldKey)) return edits[fieldKey];
        var saved = ((this.props.data.AIProviders || {}).providers || {})[providerKey] || {};
        return saved[fieldKey] || '';
    }

    setField = (providerKey, fieldKey, value) => {
        this.setState(function(s) {
            var edits = Object.assign({}, s.edits);
            edits[providerKey] = Object.assign({}, edits[providerKey] || {}, {});
            edits[providerKey][fieldKey] = value;
            return { edits: edits };
        });
    }

    isDirty(providerKey) {
        return !!this.state.edits[providerKey];
    }

    save = (providerKey) => {
        var saved = ((this.props.data.AIProviders || {}).providers || {})[providerKey] || {};
        var merged = Object.assign({}, saved, this.state.edits[providerKey] || {});
        this.props.ws.send(JSON.stringify({
            route: 'saveAIProviders',
            providers: (function() { var o = {}; o[providerKey] = merged; return o; })()
        }));
        this.setState({ savingKey: providerKey });
    }

    toggleReveal = (key) => {
        this.setState(function(s) {
            var r = Object.assign({}, s.reveal);
            r[key] = !r[key];
            return { reveal: r };
        });
    }

    renderProvider(p) {
        var canEdit = this.props.checkAccess ? this.props.checkAccess('AIProviders', 'Edit') : true;
        var dirty = this.isDirty(p.key);
        var saving = this.state.savingKey === p.key;
        return (
            <div key={p.key} style={{ background: '#fff', border: '1px solid #e3e7ee', borderRadius: '10px', padding: '20px 24px', marginBottom: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <div style={{ fontSize: '17px', fontWeight: '700', color: '#222' }}>{p.name}</div>
                    {(function() {
                        var saved = ((this.props.data.AIProviders || {}).providers || {})[p.key] || {};
                        var hasKey = !!saved.apiKey;
                        return (
                            <span style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px', textTransform: 'uppercase', padding: '3px 9px', borderRadius: '20px', background: hasKey ? '#e6f5ec' : '#f3f3f3', color: hasKey ? '#1d7a3f' : '#888' }}>
                                {hasKey ? 'Configured' : 'Not configured'}
                            </span>
                        );
                    }.bind(this))()}
                </div>
                <div style={{ fontSize: '12px', color: '#777', marginBottom: '14px', lineHeight: '1.5' }}>{p.description}</div>
                {p.fields.map(function(f) {
                    var value = this.getValue(p.key, f.key);
                    var revealed = this.state.reveal[p.key + '_' + f.key];
                    return (
                        <div key={f.key} style={{ marginBottom: '14px' }}>
                            <label style={labelStyle}>{f.label}</label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={f.secret && !revealed ? 'password' : 'text'}
                                    value={value}
                                    placeholder={f.placeholder || ''}
                                    autoComplete="off"
                                    disabled={!canEdit}
                                    onChange={function(e) { this.setField(p.key, f.key, e.target.value); }.bind(this)}
                                    style={Object.assign({}, inputStyle, f.secret ? { paddingRight: '64px', fontFamily: revealed ? 'inherit' : 'monospace' } : {})}
                                />
                                {f.secret && (
                                    <button
                                        type="button"
                                        onClick={function() { this.toggleReveal(p.key + '_' + f.key); }.bind(this)}
                                        style={{ position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#2A6AA9', fontSize: '11px', fontWeight: '600', cursor: 'pointer', padding: '4px 8px' }}
                                    >{revealed ? 'Hide' : 'Show'}</button>
                                )}
                            </div>
                        </div>
                    );
                }.bind(this))}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {canEdit && saving && <div className="loader" style={{ margin: 0 }}></div>}
                    {canEdit && !saving && dirty && <SaveButton onClick={function() { this.save(p.key); }.bind(this)} />}
                    {dirty && !saving && <span style={{ fontSize: '12px', color: '#888' }}>Unsaved changes</span>}
                    {!dirty && !saving && <span style={{ fontSize: '12px', color: '#bbb' }}>No changes</span>}
                </div>
            </div>
        );
    }

    render() {
        if (!this.props.active) return <div></div>;
        return (
            <div style={{ padding: '24px 28px', overflowY: 'auto', height: '100%', boxSizing: 'border-box', background: '#f4f6fb' }}>
                <div style={{ maxWidth: '720px' }}>
                    <div style={{ fontSize: '22px', fontWeight: '700', color: '#222', marginBottom: '6px' }}>AI Provider Settings</div>
                    <div style={{ fontSize: '13px', color: '#666', marginBottom: '24px', lineHeight: '1.5' }}>
                        API keys configured here are used by all AI features in this domain — chatbots, IVR generation, knowledge base, voice options, and more. Keys saved on individual chatbots will continue to work as a fallback.
                    </div>
                    {PROVIDERS.map(function(p) { return this.renderProvider(p); }.bind(this))}
                </div>
            </div>
        );
    }
}

const icon = "menuAI";
const roles = ["View", "Edit"];
export { AISettings, icon, roles };
